<template>
    <v-card>
        <v-card-title class="grey lighten-4 p-2" v-if="$store.state.model.reservation.group_link_id == 0">
            <h4 class="m-0" >Dates of Rental</h4>
        </v-card-title>
        <v-row class="m-2">
            <v-col cols="12" md="6" order-md="1">
                <v-row v-if="$store.state.model.reservation.group_link_id == 0">
                    <v-col cols="12">
                        <div class="date-range-container">
                            <div class="date-range-icons">
                                <v-icon>mdi-calendar-cursor</v-icon>
                            </div>
                            <div class="date-range-controls">
                                <v-dialog
                                    ref="dateStartDialog"
                                    v-model="dateStartModal"
                                    :return-value.sync="reservation.date_pickup"
                                    persistent
                                    @input="changeDatePickerMonth"
                                    width="290px"
                                >
                                    <template v-slot:activator="{ on, attrs }">
                                        <with-validation field="date_return" v-slot="{bind:v_bind}">
                                            <v-text-field
                                                v-model="datePickupFormatted"
                                                label="Start Day"
                                                hint="Day you start skiing?"
                                                :persistent-hint="true"
                                                :error="v_bind.error"
                                                :error-messages="v_bind.errorMessages"
                                                readonly
                                                v-bind="attrs"
                                                v-on="on"
                                            ></v-text-field>
                                        </with-validation>
                                    </template>
                                    <div class="datepicker-wrapper" @click="setDateReturn">
                                        <h5 class="datepicker-header primary text-center white--text pt-3 mb-0">
                                            Start Date
                                        </h5>
                                        <v-date-picker
                                            class="custom-current-date-black"
                                            style="border-top-left-radius: 0;border-top-right-radius: 0"
                                            @change="validate(['date_pickup'])"
                                            :allowed-dates="datePickupAllowedDate"
                                            v-model="reservation.date_pickup"
                                            @input="$refs.dateStartDialog.save(reservation.date_pickup)"
                                            scrollable
                                        >
                                            <v-spacer></v-spacer>
                                            <v-btn
                                                text
                                                color="primary"
                                                @click="dateStartModal = false"
                                            >
                                                Cancel
                                            </v-btn>
                                        </v-date-picker>
                                    </div>
                                </v-dialog>
                                <v-dialog

                                    ref="dateEndDialog"
                                    v-model="dateEndModal"
                                    :return-value.sync="reservation.date_return"
                                    persistent
                                    width="290px"
                                >

                                    <template v-slot:activator="{ on, attrs }">
                                        <v-slide-x-transition>

                                            <with-validation field="date_return" v-slot="{bind:v_bind}">

                                                <v-text-field
                                                    class="ml-2"
                                                    v-model="dateReturnFormatted"
                                                    label="End Day"
                                                    :persistent-hint="true"
                                                    hint="Last day skiing? "
                                                    readonly
                                                    v-bind="attrs"
                                                    v-on="on"
                                                    :error="v_bind.error"
                                                    :error-messages="v_bind.errorMessages"
                                                ></v-text-field>
                                            </with-validation>
                                        </v-slide-x-transition>
                                    </template>
                                    <div class="datepicker-wrapper">
                                        <h5 class="datepicker-header primary text-center white--text pt-3 mb-0">
                                            End Date
                                        </h5>
                                        <v-date-picker
                                            style="border-top-left-radius: 0;border-top-right-radius: 0"
                                            class="custom-current-date-black"
                                            @change="validate(['date_return'])"
                                            :allowed-dates="dateReturnAllowedDate"
                                            v-model="reservation.date_return"
                                            @input="$refs.dateEndDialog.save(reservation.date_return)"
                                            scrollable
                                        >
                                            <v-spacer></v-spacer>
                                            <v-btn
                                                text
                                                color="primary"
                                                @click="dateEndModal = false"
                                            >
                                                Cancel
                                            </v-btn>
                                        </v-date-picker>
                                    </div>
                                </v-dialog>
                            </div>
                        </div>
                    </v-col>
                </v-row>


                <v-row class="mt-5">
                    <v-col class="flex-grow-0 align-self-end p-0" style="flex-basis: 25px">
                        <v-icon style="margin-bottom: 10px;margin-left:10px">mdi-account-multiple</v-icon>
                    </v-col>
                    <v-col>
                        <with-validation v-slot="{ bind, on }" field="reservees_number">
                            <v-v-step-number
                                v-bind="bind"
                                v-on="on"
                                :min="1"
                                :max="($store.state.resources.config.frontend_view_folder === 'frontend.tygart') ? 25 : 20"
                            ></v-v-step-number>
                        </with-validation>
                    </v-col>
                </v-row>

            </v-col>
            <v-col order-md="2" v-if="$store.state.model.reservation.group_link_id == 0">
                <v-col v-if="is_local_accommodations" cols="12"  >
                    <h5>Delivery Location</h5>
                    <v-row class="m-2">
                        <v-text-field v-model="reservation.local_accommodations"></v-text-field>
                    </v-row>
                </v-col>
                <v-col cols="12"  order-md="3" v-if="!is_delivery">
                    <v-alert
                        outlined
                        elevation="2"
                    >
                        <div class="font-weight-bold mb-3">Today is {{ todayFormatted }}</div>
                        *All reservations MUST be received no later than {{ inAdvanceRentalDays * 24 }} hours in advance ( {{ timezones[selectedTimezone]}} ).

                    </v-alert>
                </v-col>
                <v-col v-if="is_coupon_show" cols="12">
                    <h5>Coupon</h5>
                    <v-row class="m-2">
                        <v-text-field v-model="reservation.coupon_id"></v-text-field>

                        <v-btn color="primary"
                               @click="applyCoupon()"
                               :disabled="book_me_host_code!==''?true:false"
                        >
                            Apply
                        </v-btn>
                    </v-row>
                    <v-row class="m-2">
                        <span :class="coupon_status===200?'text-success':'text-danger'" v-html="coupon_response"></span>
                    </v-row>
                </v-col>

                <v-col cols="12" v-if="is_windhamoutfitters">
                    <h5>Where will you be skiing today:</h5>
                    <with-validation field="location" v-slot="{bind,on}">
                        <v-select
                            v-bind="bind"
                            v-on="on"
                            menu-props="left"
                            :items="locationsList"
                            item-text="title"
                            item-value="key"
                        >
                        </v-select>
                    </with-validation>
                </v-col>
            </v-col>

        </v-row>
        <v-row class="m-2" v-if="$store.state.model.reservation.group_link_id == 0">
            <v-col cols="12" md="6" >
                <template v-if="_type==='advance' && (pickup_day_before || only_offer_day_before_pickup) && !reservation.is_delivery">
                    <template v-if="$store.state.resources.config.frontend_view_folder == 'frontend.ridesnow'">
                        <v-row class="m-2">
                            <h6>Day before</h6>
                            <v-row>
                                <v-col cols="5">
                                    <v-radio-group
                                        v-model="reservation.pickup_day"
                                        row
                                    >
                                        <v-radio
                                            label="Yes"
                                            value="day_before"
                                        ></v-radio>
                                        <v-radio
                                            v-if="!only_offer_day_before_pickup"
                                            label="No"
                                            value="day_of"
                                        ></v-radio>
                                    </v-radio-group>
                                </v-col>
                                <v-col cols="7">
                                    <v-select
                                        v-model="reservation.pickup_day_time"
                                        :items="pickup_times[reservation.pickup_day]"
                                        item-value="value"
                                        item-text="name"
                                        label="Select pickup time"
                                    >
                                    </v-select>
                                </v-col>
                            </v-row>
                        </v-row>
                    </template>
                    <template v-else>
                        <div style="display: flex; align-items: flex-start; justify-content: space-between; width: 100%;">
                            <template v-if="!is_backcountrysafary && !is_adventure && !is_essentials">
                                <div>
                                    <h5>
                                        <v-icon>mdi-av-timer</v-icon>
                                        <span>Do you <span v-if="is_velvetroperentals">Deliver</span><span v-else>want to pick up </span> the day before?</span>
                                    </h5>
                                    <v-radio-group column v-model="reservation.pickup_day">
                                        <v-radio
                                            value="day_before"
                                            :label="(is_velvetroperentals?'Delivery':'Pick up')+' the day before ' + pick_up_day_before_text"
                                        ></v-radio>
                                        <v-radio
                                            v-if="!only_offer_day_before_pickup"
                                            value="day_of"
                                            :label="(is_velvetroperentals?'Delivery':'Pick up')+' day of'"
                                        ></v-radio>
                                    </v-radio-group>
                                </div>
                            </template>
                        </div>
                    </template>

                    <template v-if="is_backcountrysafary || is_adventure || is_essentials">
                        <v-row class="m-2">
                            <h6>Day before</h6>
                            <v-row>
                                <v-col cols="5">
                                    <v-radio-group
                                        v-model="reservation.pickup_day"
                                        row
                                    >
                                        <v-radio
                                            label="Yes"
                                            value="day_before"
                                        ></v-radio>
                                        <v-radio
                                            v-if="!only_offer_day_before_pickup"
                                            label="No"
                                            value="day_of"
                                        ></v-radio>
                                    </v-radio-group>
                                </v-col>
                                <v-col cols="7">
                                    <v-select
                                        v-model="reservation.pickup_day_time"
                                        :items="pickup_times[reservation.pickup_day]"
                                        item-value="value"
                                        item-text="time"
                                        label="Select preferred time"
                                    >
                                    </v-select>
                                </v-col>
                            </v-row>
                        </v-row>
                    </template>
                </template>
            </v-col>
            <v-col cols="12" md="6">
                <template v-if="return_day_after">
                    <div>
                        <h5>
                            <v-icon>mdi-av-timer</v-icon>
                            <span>Do you want to return the day after?</span>
                        </h5>
                        <v-radio-group column v-model="reservation.return_day_after">
                            <v-radio value="yes" label="Yes"></v-radio>
                            <v-radio value="no" label="No"></v-radio>
                        </v-radio-group>
                    </div>
                </template>
            </v-col>
            <v-col cols="12" md="6" v-if="is_adventure">
                <v-row class="m-2">
                    <h6>Please Select a Location:</h6>
                    <v-radio-group
                        v-model="reservation.location"
                        row
                    >
                        <v-radio
                            label="South side Location"
                            value="south"
                        ></v-radio>
                        <v-radio
                            label="North side Location"
                            value="north"
                        ></v-radio>
                    </v-radio-group>
                </v-row>
            </v-col>


            <template v-if="is_backcountrysafary">
                <v-col cols="7" class="mt-7">
                    <h6>Do you know the Property Name or Address you will be staying:</h6>
                </v-col>
                <v-col cols="5">
                    <v-radio-group
                        v-model="show_address_modal"
                        row>
                        <v-radio
                            label="Yes"
                            :value=true
                        ></v-radio>
                        <v-radio
                            label="No"
                            :value=false
                        ></v-radio>
                    </v-radio-group>
                </v-col>
            </template>
        </v-row>
    </v-card>


</template>
<script>
import UiManagerMixin from "../../../../mixins/UiManagerMixin";
import moment                   from 'moment';
import DateUtilsMixin        from "../../../../mixins/DateUtilsMixin";
import ValidatableComponent     from "../../../../mixins/ValidatableComponent";
import {mapActions, mapGetters}             from "vuex";
import VVRangeDatepickerDialog  from "../../../../components/inputs/VVRangeDatepickerDialog";
import VVStepNumber             from "../../../../components/inputs/VVStepNumber";
import WithValidation           from "../../../../components/inputs/WithValidation";
import reservation_form__fields from "../../../../validation/fields/reservation_form__fields";
import reservation_form__rules  from "../../../../validation/scenarios/reservation_form__rules";

export default {
    name      : "DatesOfRental",
    components: {VVRangeDatepickerDialog, VVStepNumber, WithValidation},
    props     : ['validationId'],
    mixins    : [ValidatableComponent, DateUtilsMixin, UiManagerMixin],
    data      : () => ({
        dateStartModal: false,
        dateEndModal  : false,
        show_address_modal  : false,
        locationsList: [
            {
                key: "windham",
                title: "Windham Mountain"
            },
            {
                key: "hunter",
                title: "Hunter Mountain"
            },
            {
                key: "plattekill",
                title: "Plattekill Mountain"
            },
            {
                key: "belleayre",
                title: "Belleayre Mountain"
            }
        ]
    }),

    methods   : {
        ...mapActions(['load__pickup_hours', 'do_apply_coupon']),
        async applyCoupon() {
            this.do_apply_coupon();
        },
        datePickupAllowedDate(date) {
            let disableDate = false;
            let today  =  moment().format('YYYY-MM-DD');
            if(this.$store.state.resources.config.module_type_enabled != 0 && this.$store.state.resources.config.module_type == 'module_12'){
                if(this.$store.state.resources.config.blocked_dates!==null){
                    for (const [key, value] of Object.entries(this.$store.state.resources.config.blocked_dates)) {
                        if(value.start!==null && value.end!==null) {
                            disableDate = moment(date, 'YYYY-MM-DD').isBetween(moment(value.start, 'MM/DD/YYYY'), moment(value.end, 'MM/DD/YYYY'), null, '[]');
                            if (disableDate) break;
                        }
                    }
                }
                let start =  moment(this.$store.state.resources.config.season_start).format('YYYY-MM-DD') > moment(new Date()).format('YYYY-MM-DD')?this.$store.state.resources.config.season_start:moment();
                if (  today > start ) {
                    start = today;
                }

                let season_end = this.$store.state.resources.config.season_end;


                if(this.inAdvanceRentalDays!==0){
                    start = moment(start).startOf('day').add((this.inAdvanceRentalDays - 1) , 'days')
                }
                if(this.inAdvanceRentalDays==0 && this.only_offer_day_before_pickup){
                    start = moment(start).startOf('day').add(1 , 'days')
                }
                let startDate = moment(start, 'YYYY-MM-DD');
                let endDate = moment(season_end).format('YYYY-MM-DD');

                season_end = this.dt_obj_from_user(season_end);
                let startDay = moment(this.$store.state.resources.config.season_start).format('YYYY-MM-DD') > moment(new Date()).format('YYYY-MM-DD')?this.$store.state.resources.config.season_start:moment();

                let allowedData = (moment(moment(startDay).format('YYYY-MM-DD')).isSame(moment(date).format('YYYY-MM-DD')) || moment(moment(startDay).format('YYYY-MM-DD')).isBefore(moment(date).format('YYYY-MM-DD'))) && season_end.endOf('day') >= moment(date, 'YYYY-MM-DD');
                // let allowedData = (startDate < moment(date, 'YYYY-MM-DD')) && (moment(date, 'YYYY-MM-DD') <= moment(endDate, 'YYYY-MM-DD'));

                if(this.reservation.single_day_type && this.reservation.single_day_type==='night'){
                    allowedData = (moment(date).format('YYYY-MM-DD') === moment(startDay).format('YYYY-MM-DD')) && season_end.endOf('day') >= moment(date, 'YYYY-MM-DD');
                }

                return !disableDate && allowedData;
            }else{
                let shopDisableDate = false;
                if(this.$store.state.resources.config.blocked_dates!==null){
                    for (const [key, value] of Object.entries(this.$store.state.resources.config.blocked_dates)) {
                        if(value.start!==null && value.end!==null) {
                            disableDate = moment(date, 'YYYY-MM-DD').isBetween(moment(value.start, 'MM/DD/YYYY'), moment(value.end, 'MM/DD/YYYY'), null, '[]');
                            if (disableDate) break;
                        }
                    }
                }
                if(this.$store.state.resources.config.shop_blocked_dates!==null){
                    for (const [key, value] of Object.entries(this.$store.state.resources.config.shop_blocked_dates)) {
                        if(value.start!==null && value.end!==null) {
                            shopDisableDate = moment(date, 'YYYY-MM-DD').isBetween(moment(value.start, 'MM/DD/YYYY'), moment(value.end, 'MM/DD/YYYY'), null, '[]');
                            if (shopDisableDate) break;
                        }
                    }
                }
                let disableFridays = false;
                if(this.reservation.single_day_type==='night') {
                    if (this.$store.state.resources.config.blocked_fridays !== null && this.$store.state.resources.config.blocked_fridays.length != 0) {
                        for (const value of this.$store.state.resources.config.blocked_fridays.split(',')) {
                            if (value !== null) {
                                disableFridays = moment(date, 'YYYY-MM-DD').isSame(moment(value, 'MM/DD/YYYY'));
                                if (disableFridays) break;
                            }
                        }
                    }
                }
                let season_end = this.$store.state.resources.config.season_end;
                season_end = this.dt_obj_from_user(season_end);
                let add_days = this.inAdvanceRentalDays;
                if(add_days==0 && this.only_offer_day_before_pickup){
                    add_days = 1;
                }

                let startDay = moment(this.$store.state.resources.config.season_start).format('YYYY-MM-DD') > moment(new Date()).format('YYYY-MM-DD')?this.$store.state.resources.config.season_start:moment();
                let allowStatus = !disableDate && !shopDisableDate && !disableFridays && (moment(moment(startDay).add(add_days, 'days').format('YYYY-MM-DD')).isSame(moment(date).format('YYYY-MM-DD')) || moment(moment(startDay).add(add_days, 'days').format('YYYY-MM-DD')).isBefore(moment(date).format('YYYY-MM-DD'))) && season_end.endOf('day') >= moment(date, 'YYYY-MM-DD');
                if(this.reservation.single_day_type==='night' && this.frontend_view_folder === 'frontend.skigd'){
                    if(moment(date).month() == 0 ){
                        allowStatus = allowStatus && (moment(date).day()==5 || moment(date).day()==6);
                    }else{
                        allowStatus = allowStatus && (moment(date).day()==5);
                    }
                }
                return allowStatus;
            }
        },
        dateReturnAllowedDate(date) {
            let disableDate = false;
            if(this.$store.state.resources.config.module_type_enabled != 0 && this.$store.state.resources.config.module_type == 'module_12'){
                if(this.$store.state.resources.config.blocked_dates!==null){
                    for (const [key, value] of Object.entries(this.$store.state.resources.config.blocked_dates)) {
                        if(value.start!==null && value.end!==null) {
                            disableDate = moment(date, 'YYYY-MM-DD').isBetween(moment(value.start, 'MM/DD/YYYY'), moment(value.end, 'MM/DD/YYYY'), null, '[]');
                            if (disableDate) break;
                        }
                    }
                }
                let allowedData = moment(this.reservation.date_pickup, 'YYYY-MM-DD') <= moment(date, 'YYYY-MM-DD');
                let season_end = this.$store.state.resources.config.season_end;
                season_end = this.dt_obj_from_user(season_end);
                let startDay = moment(this.$store.state.resources.config.season_start).format('YYYY-MM-DD') > moment(new Date()).format('YYYY-MM-DD')?this.$store.state.resources.config.season_start:moment();

                if(this.reservation.single_day_type){
                    if(this.reservation.single_day_type==='night' || this.reservation.single_day_type==='afternoon'){
                        allowedData = moment(date).format('YYYY-MM-DD') === moment(startDay).format('YYYY-MM-DD');
                    }else if(this.reservation.single_day_type==='multiday'){
                        allowedData = moment(this.reservation.date_pickup, 'YYYY-MM-DD').add(1 , 'days') <= moment(date, 'YYYY-MM-DD');
                    } else{
                        allowedData = moment(date).format('YYYY-MM-DD') === moment(this.reservation.date_pickup).format('YYYY-MM-DD');
                    }
                }
                return !disableDate && allowedData && season_end.endOf('day') >= moment(date, 'YYYY-MM-DD');
            }else{
                let shopDisableDate = false;
                if(this.$store.state.resources.config.blocked_dates!==null){
                    for (const [key, value] of Object.entries(this.$store.state.resources.config.blocked_dates)) {
                        if(value.start!==null && value.end!==null) {
                            disableDate = moment(date, 'YYYY-MM-DD').isBetween(moment(value.start, 'MM/DD/YYYY'), moment(value.end, 'MM/DD/YYYY'), null, '[]');
                            if (disableDate) break;
                        }
                    }
                }
                if(this.$store.state.resources.config.shop_blocked_dates!==null){
                    for (const [key, value] of Object.entries(this.$store.state.resources.config.shop_blocked_dates)) {
                        if(value.start!==null && value.end!==null) {
                            shopDisableDate = moment(date, 'YYYY-MM-DD').isBetween(moment(value.start, 'MM/DD/YYYY'), moment(value.end, 'MM/DD/YYYY'), null, '[]');
                            if (shopDisableDate) break;
                        }
                    }
                }
                let season_end = this.$store.state.resources.config.season_end;
                season_end = this.dt_obj_from_user(season_end);
                let single_day_allow = true;
                if(this.reservation.single_day_type==='night' || this.reservation.single_day_type==='afternoon'){
                    single_day_allow = moment(date).format('YYYY-MM-DD') === moment(this.reservation.date_pickup).format('YYYY-MM-DD');
                }
                let allow_one_day_reservation = true;
                if(this.minimum_2_days_reservation){
                    allow_one_day_reservation = moment(date).format('YYYY-MM-DD') !== moment(this.reservation.date_pickup).format('YYYY-MM-DD');
                }
                if(this.minimum_3_days_reservation){
                    allow_one_day_reservation = moment(date).diff(moment(this.reservation.date_pickup), 'days')>=2;
                }
                if (this.disabled_2nd_and_3rd_day) {
                    const diffDays = moment(date).diff(moment(this.reservation.date_pickup), 'days');
                    allow_one_day_reservation = diffDays === 0 || diffDays >= 3;
                }
                return  !disableDate && !shopDisableDate && !parseInt(this.$store.state.resources.config.one_days_rate) ? moment(this.reservation.date_pickup, 'YYYY-MM-DD') <= moment(date, 'YYYY-MM-DD') && season_end.endOf('day') >= moment(date, 'YYYY-MM-DD') && single_day_allow && allow_one_day_reservation : moment(date, 'YYYY-MM-DD').diff(moment(this.reservation.date_pickup), 'days')===0;
            }
        },

        async updatePickupHours() {
            if (this.reservation.date_pickup && this.reservation.date_return) {
                await this.load__pickup_hours();
                this.reservation.pickup_hour = this.pickupHours[0].value;
            }
        },
        changeDatePickerMonth(){
            this.reservation.date_return = null
            if(this.reservation.date_pickup == null){
                let startDay = moment(this.$store.state.resources.config.season_start).format('YYYY-MM-DD') > moment(new Date()).format('YYYY-MM-DD')?this.$store.state.resources.config.season_start:new Date();
                startDay = moment(startDay).add(this.$store.state.resources.config.in_advance_rental_days, 'days')
                if(this.$store.state.model.reservation._type == "advance" && (moment(this.$store.state.resources.config.season_start).format('YYYY-MM-DD') > moment(new Date()).format('YYYY-MM-DD'))){
                    this.$store.state.model.reservation.date_pickup = moment(startDay).format('YYYY-MM-DD');
                }
                if(this.$store.state.resources.config.blocked_dates!=null && moment(this.$store.state.resources.config.blocked_dates[1].start).format('YYYY-MM-DD') <  moment(new Date()).format('YYYY-MM-DD') && moment(this.$store.state.resources.config.blocked_dates[1].end).format('YYYY-MM-DD') >  moment(new Date()).format('YYYY-MM-DD')){
                    this.$store.state.model.reservation.date_pickup =   moment(this.$store.state.resources.config.blocked_dates[1].end).format('YYYY-MM-DD');
                }
            }
        },
        setDateReturn(){
            if(this.reservation.date_return == null){
                this.dateEndModal = true;
                this.$store.state.model.reservation.date_return = this.$store.state.model.reservation.date_pickup;
            }
        },
        is_in_special_period() {
            let day = this.$store.state.model.reservation.date_pickup;
            let is_in_special_period = false;
            if(this.$store.state.resources.config.special_period_control && this.$store.state.resources.config.special_period!==null){
                for (const [key, value] of Object.entries(this.$store.state.resources.config.special_period)) {
                    if(value.start!==null && value.end!==null) {
                        is_in_special_period = moment(day, 'YYYY-MM-DD').isBetween(moment(value.start, 'MM/DD/YYYY'), moment(value.end, 'MM/DD/YYYY'), null, '[]');
                        if (is_in_special_period){
                            this.$store.commit('set_special_period_increase', parseFloat(value.special_rate));
                            this.$store.commit('set_special_period_start_date', value.start);
                            this.$store.commit('set_special_period_end_date', value.end);
                            this.$store.commit('set_special_period_rate_type', value.special_rate_type ? value.special_rate_type : 'percent');
                            break;
                        }
                    }
                }
            }
            if(!is_in_special_period){
                this.$store.commit('set_special_period_increase', 0);
            }
            this.$store.commit('set_is_special_period_date', is_in_special_period);
        }
    },
    computed  : {
        dateFormat() {
            return this.$store.state.config.dateFormat;
        },
        blocked_fridays() {
            return this.$store.state.config.blocked_fridays;
        },
        _type(){
            return this.$store.state.model.reservation._type;
        },
        pickup_day_before(){
            return parseInt(this.$store.state.resources.config.pickup_day_before);
        },
        return_day_after(){
            return parseInt(this.$store.state.resources.config.return_day_after);
        },
        only_offer_day_before_pickup(){
            return parseInt(this.$store.state.resources.config.only_offer_day_before_pickup);
        },
        inAdvanceRentalDays() {
            return this.$store.state.resources.config.in_advance_rental_days;
        },
        useCoupon() {
            return this.$store.state.resources.config.use_coupons && this.$store.state.resources.config.hide_coupon_from_advance_reservation == '0';
        },
        timezones() {
            let timezones = [];
            timezones['America/Los_Angeles'] = "Pacific Standard Time";
            timezones['America/New_York'] = 'Eastern Standard Time';
            timezones['America/Chicago'] = 'Central Standard Time';
            timezones['America/Denver'] = 'Mountain Standard Time';
            timezones['America/Anchorage'] = 'Alaska Standard Time';

            return timezones;
        },
        selectedTimezone() {
            return this.$store.state.resources.config.selected_timezone;
        },
        todayFormatted() {
            return moment().format(this.dateFormat);
        },
        pick_up_day_before_text(){
            return this.$store.state.resources.config.pick_up_day_before_text!='' ?'( '+this.$store.state.resources.config.pick_up_day_before_text +' )' :'';
        },
        totalDays() {
            if (this.reservation.date_pickup && this.reservation.date_return) {
                return moment(this.reservation.date_return).diff(moment(this.reservation.date_pickup), 'days');
            }
            return 0;
        },
        reservation() {
            return this.$store.state.model.reservation;
        },
        dateReturnFormatted() {
            if (this.reservation.date_return)
                return moment(this.reservation.date_return, 'YYYY-MM-DD').format(this.dateFormat);
            else
                return '';
        },
        datePickupFormatted() {
            if (this.reservation.date_pickup)
                return moment(this.reservation.date_pickup, 'YYYY-MM-DD').format(this.dateFormat);
            else
                return '';
        },
        delivery(){
            return parseInt(this.$store.state.resources.config.delivery);
        },
        delivery_coupons(){
            return parseInt(this.$store.state.resources.config.delivery_coupons);
        },
        is_coupon_show(){
            return (!window.location.href.includes('delivery') && this.useCoupon) || (window.location.href.includes('delivery') && this.delivery && this.delivery_coupons && this.useCoupon);
        },
        is_local_accommodations(){
            return parseInt(this.$store.state.resources.config.local_accommodations);
        },
        is_delivery(){
            return window.location.href.includes('delivery');
        },
        special_period_control() {
            return parseInt(this.$store.state.resources.config.special_period_control);
        },
        special_period() {
            return this.$store.state.resources.config.special_period;
        },
        minimum_2_days_reservation() {
            return parseInt(this.$store.state.resources.config.minimum_2_days_reservation);
        },
        minimum_3_days_reservation() {
            return parseInt(this.$store.state.resources.config.minimum_3_days_reservation);
        },
        disabled_2nd_and_3rd_day() {
            return parseInt(this.$store.state.resources.config.disabled_2nd_and_3rd_day);
        },
        pickup_times() {
            let pickup_time = this.$store.state.resources.config.pickup_times;
            if(!this.is_backcountrysafary && !this.is_adventure && !this.is_essentials){
                pickup_time['day_before'] = pickup_time['day_before'].map((x)=>{
                    return {
                        "name": x.charAt(0)
                            .toUpperCase()+ x.substr(1),
                        "value": x,
                    }
                });
                pickup_time['day_of'] = pickup_time['day_of'].map((x)=>{
                    return {
                        "name": x.charAt(0)
                            .toUpperCase()+ x.substr(1),
                        "value": x,
                    }
                });
            }
            return pickup_time;
        },
        is_backcountrysafary(){
            if(this.$store.state.resources.config.frontend_view_folder=="frontend.backcountrysafary" && !window.location.href.includes("delivery")){
                return true;
            }
            return false;
        },
        is_adventure(){
            if(this.$store.state.resources.config.frontend_view_folder=="frontend.adventure" && !window.location.href.includes("delivery")){
                return true;
            }
            return false;
        },
        is_essentials(){
            if(this.$store.state.resources.config.frontend_view_folder=="frontend.essentials" && !window.location.href.includes("delivery")){
                return true;
            }
            return false;
        },
        is_velvetroperentals(){
            if(this.$store.state.resources.config.frontend_view_folder=="frontend.velvetroperentals" && !window.location.href.includes("delivery")){
                return true;
            }
            return false;
        },
        frontend_view_folder(){
            return this.$store.state.resources.config.frontend_view_folder;
        },
        is_windhamoutfitters() {
            return window.location.hostname == 'skirentals.windhamoutfitters.com';
        },
        ...mapGetters(['coupon_response', 'coupon_status', 'book_me_host_code'])

    },
    watch     : {
        'reservation.date_pickup': function (newVal, oldVal) {
            this.is_in_special_period();
            // if (!this.reservation.date_return && newVal) {
            //     this.dateEndModal = true;
            //     this.$store.state.model.reservation.date_return = newVal;
            // }
        },
        '$store.state.model.reservation.date_return': function (newVal, oldVal) {
            if(this.$store.state.model.reservation.coupon_id && this.$store.state.model.reservation.coupon_id!==""){
                this.applyCoupon();
            }
        },
        show_address_modal(newVal) {
            if(newVal){
                this.ui__openModalByName({name:'dialog_delivery_address'})
            }
        },
        validationId(val){
            this.withValidation({validationId: val})
        }
    },
    created() {
        if(this.only_offer_day_before_pickup){
            this.$store.state.model.reservation.pickup_day = "day_before";

        }
        if(this.book_me_host_code!==''){
            this.$store.state.model.reservation.coupon_id = this.book_me_host_code;
        }
    }
}
</script>

<style scoped lang="scss">
.date-range-container {
    display: flex;
    flex-direction: row;
    justify-content: stretch;

    .date-range-icons {
        display: flex;
        flex-direction: column;
        justify-content: center;

        margin-right: 0.5em;
    }

    .date-range-controls {
        flex-grow: 1;
        display: flex;
        justify-content: stretch;
    }
}

</style>

<style>

.date-range-icons .v-icon {
    margin-bottom: 3px;
}

.v-application .custom-current-date-black .accent--text.v-date-picker-table__current{
    color: #000 !important;
    border-color: #1976d2 !important;
}
.v-application .custom-current-date-black .theme--light.v-btn.v-btn--disabled{
    color: rgba(0, 0, 0, 0.26) !important;
    border-color: rgba(0, 0, 0, 0.26) !important;
}


</style>
